'use strict';

var base = require('../product/base');
var focusHelper = require('../components/focus');
var location = window.location;

var initializeCarousels = require('../product/imageCarousel').initializeCarousels;

/**
 * Opens the promo code accordion if a coupon is applied.
 */
function openPromoCodeAccordionIfCouponApplied() {
    if ($('.coupons-and-promos .coupon-price-adjustment').length > 0) {
        $('#promo-code-section .title').attr('aria-expanded', 'true');
        $('#promo-code-section').addClass('active');
    }
}

/**
 * Toggle class for minicart quantity
 * @param {string} basketCount - basket count
 */
function quantityToggle(basketCount) {
    if (basketCount === 0) {
        $('.minicart-quantity').removeClass('d-block').addClass('d-none');
    } else {
        $('.minicart-quantity').removeClass('d-none').addClass('d-block');
    }
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
                + 'fade show" role="alert">'
                + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                + '<span aria-hidden="true">&times;</span>'
                + '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> '
                + '<div class="col-12 text-center"> '
                + '<h1>' + data.resources.emptyCartMsg + '</h1> '
                + '</div> '
                + '</div>');
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            quantityToggle(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.sub-total-points-js').empty().append(data?.totals?.subTotalInPoints?.formatted);

    // Minicart only values
    if (data.totals && data.totals.orderLevelDiscountTotal.value === 0) {
        $('.minicart-footer').find('.minicart-discount-js').addClass('d-none');
        $('.minicart-footer').find('.sub-total-js').addClass('d-none');
    } else {
        $('.minicart-footer').find('.minicart-discount').empty().append(data.totals.orderLevelDiscountTotal.formatted);
        $('.minicart-footer').find('.minicart-discount-js').removeClass('d-none');
        $('.minicart-footer').find('.sub-total').empty().append(data.totals.subTotal);
        $('.minicart-footer').find('.sub-total-js').removeClass('d-none');
    }
    $('.minicart-footer').find('.estimated-total-mini-cart').empty().append(data?.totals?.estimatedTotals?.formatted);
    $('.minicart-footer').find('.minicart-discount-points-js').empty().append(data?.totals?.orderDiscountInPoints?.formatted);
    $('.minicart-footer').find('.estimated-total-mini-cart-points-js').empty().append(data?.totals?.estimatedTotalsPoints?.formatted);
    if ($('.sub-total-mini-cart-points-js').length) {
        $('.sub-total-mini-cart-points-js').empty().append(data?.totals?.miniCartSubTotalInPoints?.formatted);
    }
    
    $('.shipping-cost-points-js').empty().append(data.totals.shippingCostIncluded);
    $('.tax-points-js').empty().append(data.totals.totalTaxIncluded);
    $('.grand-total-points-js').empty().append(data?.totals?.grandTotalInPoints?.formatted);
    $('.points-deficiency-js').empty().append(data?.totals?.pointsDeficiencyFormatted);
    $('.earn-formatted-points-js').empty().append(data?.totals?.totalEarnPoints?.formatted);
    if (data?.totals?.pointsDeficiencyFormatted && $('.points-toggle-control-js:checked').length > 0) {
        $('.points-deficiency-message-js').removeClass('d-none');
    } else {
        $('.points-deficiency-message-js').addClass('d-none');
    }

    if(data?.totals?.totalEarnPoints?.number && $('.points-toggle-control-js:checked').length === 0) {
        $('.cart-earn-display-message-js').removeClass('d-none');
    } else {
        $('.cart-earn-display-message-js').addClass('d-none');
    }

    quantityToggle(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
        $('.order-discount-points-js').empty().append('- '
            + data?.totals?.orderDiscountInPoints?.formatted); // eslint-disable-line no-unsafe-optional-chaining
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- '
            + data.totals.shippingLevelDiscountTotal.formatted);
        $('.shipping-discount-points-js').empty().append('- '
            + data?.totals?.shippingDiscountInPoints?.formatted); // eslint-disable-line no-unsafe-optional-chaining
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    // Shipping Handling Fee
    if (data?.totals?.shippingHandlingFee?.value) {
        $('.shipping-handling-fee').removeClass('d-none');
        $('.shipping-handling-fee-js').empty().append(data.totals.shippingHandlingFee.formatted);
        $('.shipping-handling-fee-points-js').empty().append(data.totals.shippingHandlingFeeIncluded);
    } else {
        $('.shipping-handling-fee').addClass('d-none');
    }

    data.items.forEach(function (item) {
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });

    // Additional Fee
    $('.additional-fees').empty().append(data.totals.feesHtml);
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
        + 'fade show" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching, coupon and non-coupon discount messages
 * @param {Object} cartModel - totals model
 */
function updateCartDiscounts(cartModel) {
    $('.js-coupons-and-promos').empty().append(cartModel.totals.couponDiscountsHtml); // coupon discount
    $('.js-noncoupon-discounts').empty().append(cartModel.totals.nonCouponDiscountsHtml); // non-coupon discount
    $('.js-approaching-discounts').empty().append(cartModel.approachingDiscountsHtml); // approaching discount
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';
    var addOnRestrictionsMessage = '';
    

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                const inStockClass = lineItem?.available ? 'd-none' : 'out-of-stock';

                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes para--14 mt-2 ' + inStockClass + '">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);

        data.items.forEach(function (item) {
            if (item.productRestrictions.notSoldIndividually && item.productRestrictionMsg) {
                addOnRestrictionsMessage = '<p class="line-item-attributes para--14 mt-2 add-on-restrictions">' + item.productRestrictionMsg + '</p>';
                $('.product-restriction-' + item.UUID).html(addOnRestrictionsMessage);
                $('.product-restriction-' + item.UUID).removeClass('d-none');
            } else {
                $('.product-restriction-' + item.UUID).addClass('d-none');
            }
        });
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}


/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * checks if class is disabled and removes leftglidearrow element from logical tab order
* @param {Object} $leftArrowElement - leftArrowElement
*/
function updateTabFocusOnLeftGlideArrow($leftArrowElement) {
    if($leftArrowElement.hasClass('glide__arrow--disabled')) {    
        $leftArrowElement.attr('tabindex', '-1');
    }
}

/**
 * checks if class is disabled and removes rightglidearrow element from logical tab order
 * @param {Object} $rightArrowElement - rightArrowElement
*/
function updateTabFocusOnRightGlideArrow($rightArrowElement) {
    if($rightArrowElement.hasClass('glide__arrow--disabled')) {    
        $rightArrowElement.attr('tabindex', '-1');
    }
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
            setTimeout(() => initializeCarousels($('#editProductModal').get(0)), 100);
            var $disableCurrentLeftArrow = $('#editProductModal .glide__arrow--left');
            updateTabFocusOnLeftGlideArrow($disableCurrentLeftArrow);
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 * @param {Object} productIdObject - productset Id
 */
function confirmDelete(actionUrl, productID, productName, uuid, productIdObject) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    if(productIdObject !== null || productIdObject !== '' ) {
        $deleteConfirmBtn.data('pidsObj', productIdObject);
    }
    
    $productToRemoveSpan.empty().append(productName);
}

/**
 * Add spinner to the quantity selector input field
 * 
 */
function inputSpinner() {
    $('.product-info .quantity').inputSpinner();
    $('.quantity-form').removeClass('d-none');
}

/**
 * Update Quantity and Delete selector for product set id
 * @param {Object} $currentselector - current selector of a element
 * @returns {string} - returns set of customized product set id 
 */
function updateQuantityAndDelete ($currentselector) {
    let setCustomizedPids = [];
    let productSetId; 
    let customizedProductSetSelector;
    let isMiniCart = $currentselector.parents('.minicart-section').length;

    if (isMiniCart > 0) {
        customizedProductSetSelector = $currentselector.closest('.product-line-item-details').next('.card').find('.customized-productset-container'); 
    }
    else {
        customizedProductSetSelector = $currentselector.closest('.card.product-info').find('.cart-customizedproductcontainer .customized-productset-container');
    }

    customizedProductSetSelector.each(function () {
        setCustomizedPids.push({
            pid: $(this).find('.customized-productset-items').data('pid'),
            Qty: $(this).find('.customized-productset-quantity-js').data('quantity'),
            uuid: $(this).data('uuid')
        })
    });

    productSetId = JSON.stringify(setCustomizedPids);

    return productSetId;
}

/**
 * Update Quantity value for productSetId
 * @param {Object} productSetItem - productset item for customized product
 * @param {string} isMiniCart - checks if page is minicart or not 
 */
function updateProductQuantityValue(productSetItem,isMiniCart) {
    let customizedProductSetSelector;

    if (isMiniCart > 0) {
        customizedProductSetSelector = $('.product-line-item[data-product-line-item=' + productSetItem.UUID + ']').find('.customized-productset-container');
    }
    else {
        customizedProductSetSelector = $('.card.product-info.uuid-' + productSetItem.UUID +'').find('.cart-customizedproductcontainer .customized-productset-container');
    }
    
    productSetItem.setItems.forEach(function (customSetItems) { 
        
        $(customizedProductSetSelector).each(function () {
            if($(this).data("uuid") === customSetItems.UUID) {
                $(this).find('.customized-productset-items .customized-productset-quantity-js').text(customSetItems.quantity);   
            }
        });
    });
}

module.exports = function () {
    $('body').on('pointsToggle:updated', function (e, data) {
        var url = $('.discount-container').data('url');
        var loyaltyIsPointsToggled = data?.isPointsToggled;

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: { loyaltyIsPointsToggled: loyaltyIsPointsToggled },
            success: function (response) {
                updateCartTotals(response);
                updateCartDiscounts(response);
            }
        });
    });

    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid'); 
        var pidsObj = updateQuantityAndDelete($(this));

        let productHeadlineModal =  $('#removeProductLineItemModal.product-headline-js');
        let productSetHeadlineModal = $('#removeProductSetLineItemModal.productset-headline-js');

        if (($(this).closest('.product-line-item').data('iscustomizedproductset') || $(this).closest('.card.product-info').data('iscustomizedproductset')) === true) {
            productHeadlineModal.addClass('d-none');
            productSetHeadlineModal.removeClass('d-none');
        }
        else {
            productHeadlineModal.removeClass('d-none');
            productSetHeadlineModal.addClass('d-none');
        }

        confirmDelete(actionUrl, productID, productName, uuid, pidsObj);
    });

    $('body').on('click', '.cart .modal-promotion-details, .minicart .modal-promotion-details', function (e) {
        e.preventDefault();
        $('.promotion-details-modal .modal-body').empty().html($(this).data('promotion-details'));
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid, data.pidsObj);
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var pidsObj = $(this).data('pidsObj');
        var urlParams = {
            pid: productID,
            uuid: uuid,
            pidsObj: pidsObj
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('.default-header-cart').addClass('d-none');
                    $('.cart').empty().append('<div class="row"> '
                        + '<div class="col-12 text-center empty-section"> '
                        + '<p class="display-1-desktop h1">' + data.basket.resources.emptyCartMsg + '</p>'
                        + '<p class="para--14 mt-2 pb-3">' + data.basket.resources.emptySubCartMsg + '</p>'
                        + '</div> '
                        + '</div>');
                    $('.cart').addClass('cart-empty');
                    $('.cart .empty-section').append($('.default-header-cart .btn-container').clone());
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    quantityToggle(data.basket.numItems);
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }

                    data.basket.items.forEach(function (item) {
                        if (item.productRestrictions.notSoldIndividually && item.productRestrictionMsg) {
                            var addOnRestrictionsMessage = '<p class="line-item-attributes para--14 mt-2 add-on-restrictions">' + item.productRestrictionMsg + '</p>';
                            $('.product-restriction-' + item.UUID).html(addOnRestrictionsMessage);
                            $('.product-restriction-' + item.UUID).removeClass('d-none');
                        } else {
                            $('.product-restriction-' + item.UUID).addClass('d-none');
                        }
                    });

                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    updateCartTotals(data.basket);
                    updateCartDiscounts(data.basket);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                $('body').trigger('cart:update', data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var pidsObj = updateQuantityAndDelete($(this));

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid,
            pidsObj: pidsObj
        };

        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                updateCartTotals(data);
                updateCartDiscounts(data);
                updateAvailability(data, uuid);
                validateBasket(data);
                $(this).data('pre-select-qty', quantity); 

                let currentProductSetUUID = $(this).data("uuid");
                let isMiniCart = $(this).parents('.minicart-section').length;

                data.items.forEach(function (item) { 
                    if (currentProductSetUUID  === item.UUID && item.isCustomizedSetProduct) {
                        updateProductQuantityValue(item, isMiniCart)
                    }
                });                

                $('body').trigger('cart:update', data);

                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    updateCartTotals(data);
                    updateCartDiscounts(data);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        var $couponField = $('#couponCode');
        if ($couponField.val()) {
            $couponField.val($couponField.val().trim());
        }
 
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    updateCartTotals(data);
                    updateCartDiscounts(data);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateCartDiscounts(data);
                validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.cart-edit-product-dialog');

        $('.update-cart-product-global', dialog).attr(
            'disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer)
            .closest('.cart-edit-product-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    updateCartTotals(data.cartModel);
                    updateCartDiscounts(data.cartModel);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $('.product-info.uuid-' + uuid).find('.quantity').inputSpinner();
                    $('.product-info.uuid-' + uuid).find('.quantity-form').removeClass('d-none');

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    // approaching & system discount modal
    $('body').on('click', '.approaching-promotion-details, .system-promotion-details', function (e) {
        e.preventDefault();
        $('.promotion-details-body').empty().html($(this).data('promotion-details'));
    });

    // tax estimate form
    $('form.zip-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        var $form = $('.zip-code-form');

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.zip-code-form .form-control').addClass('is-invalid');
                    $('.zip-code-form .form-control').attr('aria-describedby', 'form-zipcode-error');
                    $('.form-zipcode-error-js').empty().append(data.form.zipCode.error);
                } else if (data.cart) {
                    updateCartTotals(data.cart);
                    if (!$('.points-toggle-control-js').prop('checked')) {
                        $('.cart-zip-section').removeClass('active');
                        $('.cart-zip-section .js-button-collapsible').attr("aria-expanded", "false");
                    }
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        })
    });

    $(document).on('click', '#editProductModal .glide__arrow--right', function () {
        const $leftArrowElement = $(this).parent().siblings('.glide__arrows').find('.glide__arrow--left');
        const $currentRightArrowElement = $(this);

        if ($leftArrowElement.attr('tabindex') !== undefined) {
            $leftArrowElement.removeAttr('tabindex');
        }
        updateTabFocusOnRightGlideArrow($currentRightArrowElement);
    });

    $(document).on('click', '#editProductModal .glide__arrow--left', function () {
        const $rightArrowElement = $(this).parent().siblings('.glide__arrows').find('.glide__arrow--right');
        var $currentLeftArrowElement = $(this);
        
        if ($rightArrowElement.attr('tabindex') !== undefined) {
            $rightArrowElement.removeAttr('tabindex');
        }
        updateTabFocusOnLeftGlideArrow($currentLeftArrowElement);
    });

    inputSpinner();
    openPromoCodeAccordionIfCouponApplied();
    base.selectAttribute();
    base.variationAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
